var React = require('react');

function Buckaroo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M26.4145 21.8981C26.4145 30.9111 21.7497 38.2176 15.9953 38.2176C10.241 38.2176 5.57617 30.9111 5.57617 21.8981C5.57617 12.8851 10.241 5.57866 15.9953 5.57866C21.7497 5.57866 26.4145 12.8851 26.4145 21.8981Z","fill":"#242424","key":0}),React.createElement("path",{"d":"M38.2163 21.897C38.2163 30.91 33.5515 38.2165 27.7971 38.2165C22.0428 38.2165 17.378 30.91 17.378 21.897C17.378 12.884 22.0428 5.57751 27.7971 5.57751C33.5515 5.57752 38.2163 12.884 38.2163 21.897Z","fill":"#242424","key":1}),React.createElement("path",{"d":"M23.5911 20.9682H19.9553L21.8417 25.2188L23.5911 20.9682ZM15.9922 15.9955H17.7077L19.2679 19.4538H24.2435L25.7185 15.9955H27.434L22.4083 27.8003H21.2239L15.9922 15.9955Z","fill":"#CDD905","key":2})]);
}

Buckaroo.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Buckaroo;

Buckaroo.default = Buckaroo;
